export const ImageDropZone = {
  for(options) {
    new Kadenze.ImageDropZone(
      this._getElementSelector(options),
      this._getMessageTemplate(options),
      options.url,
      options.callbacks,
      options.currentFile,
      Object.assign({}, this._getDropZoneOptions(options), this.defaultDropZoneOptions)
    )
  },

  defaultDropZoneOptions: {
    cropOptions: {
      modalId: 'crop_modal'
    },
  },

  defaultMsgOptions: {
    template: "generic",
    maxFilesize: 10,
    dropFilesTitle: I18n.t('drop_file_editor.drop_file_title'),
    dragAndDrop: I18n.t('drop_file_editor.drag_and_drop'),
    browseFiles: I18n.t('drop_file_editor.browse_files'),
    dimentionLabel: I18n.t('drop_file_editor.dimensions_label'),
    maxFilesizeLabel: I18n.t('drop_file_editor.max_file_size'),
    fileTypesLabel: I18n.t('drop_file_editor.file_types'),
    optionalLable: I18n.t('drop_file_editor.optional'),
  },

  defaultPreviewTemplateOpts: {
    template: "generic",
    previewable: true,
    hideFileStats: true,
    nameLabel: I18n.t('file_preview.name'),
    sizeLabel: I18n.t('file_preview.size'),
    previewLabel: I18n.t('file_preview.preview'),
    removeLabel: I18n.t('file_preview.remove_file'),
    fileUploadProgressLabel: I18n.t('file_preview.file_upload_progress'),
  },

  _getElementSelector(options) {
    return `#${options.elementName}-img-dz`
  },

  _getDropZoneOptions(options) {
    if (options.dropZone.previewOptions) {
      return this._getDropZoneOptionsWithPreview(options.dropZone)
    } else {
      return options.dropZone
    }
  },

  _getDropZoneOptionsWithPreview(dzOptions) {
    return Object.assign(
      {},
      dzOptions,
      {
        previewTemplate: this._getDropZonePreviewTemplate(
          dzOptions.previewOptions
        ),
        previewable: true
      }
    )
  },

  _getDropZonePreviewTemplate(previewOptions) {
    const options = Object.assign(
      {},
      this.defaultPreviewTemplateOpts,
      previewOptions
    )

    return JST[this._getPreviewJSTPath(options)](options)
  },

  _getPreviewJSTPath(templateOptions) {
    return `templates/dropzone-${templateOptions.template}-img-preview`
  },

  _getMessageTemplate(options) {
    const msgOptions = Object.assign(
      {},
      this.defaultMsgOptions,
      options.message,
      {
        acceptedFiles: options.dropZone.acceptedFiles
      }
    )

    return JST[this._getMessageTemplatePath(msgOptions)](msgOptions)
  },

  _getMessageTemplatePath(templateOptions) {
    return `templates/dropzone-${templateOptions.template}`
  },
}
